import React, {Component} from "react";
import Xhr from "../../../helpers/Xhr";

class EditLeague extends Component {
	state = {
		maximum : 0,
		reserve : 0
	};

	componentWillMount() {
		const {league} = this.props;
		if ( league.hasOwnProperty('maximum') && league.hasOwnProperty('reserve') ) {
			this.setState({
				maximum : league.maximum,
				reserve : league.reserve
			});
		}
	}

	inputChange(e) {
		const stateChange = {
			[e.target.name] : e.target.value
		};

		this.setState({...this.state, ...stateChange})
	}

	changeData() {
		const {league} = this.props;
		const data = {
			leagueId : +league.id,
			maximum  : this.state.maximum,
			reserve  : this.state.reserve
		};

		Xhr.changeLeagueLive(data).then((resp) => {
			if ( resp.status === 'error' ) {
				alert(resp.messages);
			}
		});
	}

	render() {
		const {league} = this.props;
		if ( !league.hasOwnProperty('maximum') || !league.hasOwnProperty('reserve') ) {
			return null;
		}

		const inputStyle = {
			width       : 50,
			outline     : 'none',
			marginRight : 5
		};

		const buttonStyle = {
			outline : 'none',
			height  : 18
		};

		return (
			<span className="editor" style={{float : 'right'}}>
					<input type="text" name="maximum"
					       style={inputStyle}
					       onChange={this.inputChange.bind(this)}
					       value={this.state.maximum}/>

					<input type="text" name="reserve"
					       style={inputStyle}
					       onChange={this.inputChange.bind(this)}
					       value={this.state.reserve}/>

					<input type="button"
					       className="buttons__show"
					       style={buttonStyle}
					       name="save"
					       value="Сохранить"
					       onClick={this.changeData.bind(this)}/>
			</span>
		);
	}
}

export default EditLeague;


// WEBPACK FOOTER //
// ./src/app/pages/LineSelect/modules/EditLeague.js